import script from "./unitOverdue.vue?vue&type=script&setup=true&lang=js"
export * from "./unitOverdue.vue?vue&type=script&setup=true&lang=js"

import "./unitOverdue.vue?vue&type=style&index=0&id=5426c506&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5426c506"]])

export default __exports__